// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"styles_tooltip__u7mvb","toolTipText":"styles_toolTipText__pVBr1"};